import { gql } from '@apollo/client';

const PRE_BID_SCHEDULE_CORE_FIELDS = gql`
  fragment PreBidScheduleCoreFields on PreBidSchedule {
    id
    name
    saleWeekday
    schedule {
      start
      defaultStep
      minStep
    }
  }
`;

export const PRE_BID_SCHEDULES = gql`
  ${PRE_BID_SCHEDULE_CORE_FIELDS}
  query PreBidSchedules {
    preBidSchedules {
      ...PreBidScheduleCoreFields
    }
  }
`;

const PRE_BID_SCHEDULE_VARIABLES = `
  $name: String!
  $saleWeekday: Int
  $schedule: [PreBidScheduleLineInput!]!
`;

const PRE_BID_SCHEDULE_ARGUMENTS = `
  name: $name
  saleWeekday: $saleWeekday
  schedule: $schedule
`;

export const CREATE_PRE_BID_SCHEDULE = gql`
  ${PRE_BID_SCHEDULE_CORE_FIELDS}
  mutation CreatePreBidSchedule(
    ${PRE_BID_SCHEDULE_VARIABLES}
  ) {
    createPreBidSchedule(
      ${PRE_BID_SCHEDULE_ARGUMENTS}
    ) {
      preBidSchedule {
        ...PreBidScheduleCoreFields
      }
      errors { path, message }
    }
  }
`;

export const UPDATE_PRE_BID_SCHEDULE = gql`
  ${PRE_BID_SCHEDULE_CORE_FIELDS}
  mutation UpdatePreBidSchedule(
    $id: ID!
    ${PRE_BID_SCHEDULE_VARIABLES}
  ) {
    updatePreBidSchedule(
      id: $id
      ${PRE_BID_SCHEDULE_ARGUMENTS}
    ) {
      preBidSchedule {
        ...PreBidScheduleCoreFields
      }
      errors { path, message }
    }
  }
`;

export const HIDE_PRE_BID_SCHEDULE = gql`
  mutation HidePreBidSchedule($id: ID!) {
    hidePreBidSchedule(id: $id) {
      preBidSchedule { id }
    }
  }
`;

export const UNHIDE_PRE_BID_SCHEDULE = gql`
  mutation UnhidePreBidSchedule($id: ID!) {
    unhidePreBidSchedule(id: $id) {
      preBidSchedule { id }
    }
  }
`;
